import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    RiskDigestGeoRiskResponseRuntype,
    RiskDigestResponseRuntype,
    TimelineFilterQueryParamsRuntype,
    TopAffectedAssemblyResponseRuntype,
} from './riskManagementBackendTypes';
import {
    RiskManagementNotificationRequestRuntype,
    RiskManagementNotificationRuntype,
} from './riskNotificationsBackendTypes';

export const riskDigestEndpoints = {
    'GET /risk-management/notifications': endpoint({
        description: "Get the current user's risk management notification config",
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: RiskManagementNotificationRuntype.nullable(),
    }),

    'POST /risk-management/notifications': endpoint({
        description: "Create the current user's risk management notification config",
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RiskManagementNotificationRequestRuntype,
        responseBody: RiskManagementNotificationRuntype,
        invalidates: ['GET /risk-management/notifications'],
    }),

    'PATCH /risk-management/notifications': endpoint({
        description: "Update the current user's risk management notification config",
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RiskManagementNotificationRequestRuntype,
        responseBody: RiskManagementNotificationRuntype,
        invalidates: ['GET /risk-management/notifications'],
    }),

    'GET /risk-management/risk-digest': endpoint({
        description: 'Get the risk digest for a notification frequency or custom time window',
        pathParams: z.undefined(),
        queryParams: TimelineFilterQueryParamsRuntype,
        requestBody: z.undefined(),
        responseBody: RiskDigestResponseRuntype,
    }),

    'GET /risk-management/geo-risks': endpoint({
        description: 'Get the geo-risk snapshot for a notification frequency or custom time window',
        pathParams: z.undefined(),
        queryParams: TimelineFilterQueryParamsRuntype,
        requestBody: z.undefined(),
        responseBody: RiskDigestGeoRiskResponseRuntype,
    }),

    'GET /risk-management/top-affected-assemblies': endpoint({
        description: 'Get assemblies most affected by risk alerts for a frequency or custom time window',
        pathParams: z.undefined(),
        queryParams: TimelineFilterQueryParamsRuntype,
        requestBody: z.undefined(),
        responseBody: TopAffectedAssemblyResponseRuntype,
    }),
};
